import React from "react"
import { Route, RouteProps } from "react-router-dom"

import { useSharedContext } from "Shared"
import Unauthorised from "components/Unauthorised"

type TPrivateRouteProps = RouteProps

function Private(props: TPrivateRouteProps) {
  const { component, ...rest } = props

  // eslint-disable-next-line
  const { userId, email } = useSharedContext()
  const _component = React.useMemo(() => {
    const ok = userId && email
    return ok ? component : Unauthorised
    // eslint-disable-next-line
  }, [userId, email])

  return <Route {...rest} component={_component} />
}

export default Private
